import HomePageHeader from "../../components/HomePageHeader";
import HomePageSearchBar from "../../components/HomePageSearchBar";
import HomePageFooter from "../../components/HomePageFooter";
import styles from "./userresetpasspage.module.css";
import UserResetPassBlock from "../../components/UserResetPassBlock";
import { UserNavigator } from "../../components/UserNavigator";
export default function UserProfilePage() {
  return (
    <div className={`container-fluid h-custom ${styles.page}`}>
      <div className="row Header">
        <HomePageHeader />
        <HomePageSearchBar />
      </div>
      <div className="row Body">
        <div className="col-3 px-0">
          <UserNavigator />
        </div>
        <div className={`col-9 ${styles.userProfileBlock}`}>
          <UserResetPassBlock />
        </div>
      </div>
      <div className="row footer">
        <HomePageFooter />
      </div>
    </div>
  );
}
